import felaMonolithic from 'fela-monolithic';
import felaPluginExtend from 'fela-plugin-extend';
import felaPluginValidator from 'fela-plugin-validator';
import felaPluginFallbackValue from 'fela-plugin-fallback-value';

import * as Consts from 'constants';

const isNotProd = process.env.NODE_ENV !== Consts.env.PRODUCTION;

const enhancers = [];
// TODO: use prefixer
const plugins = [/* felaPluginPrefixer(),*/ felaPluginFallbackValue(), felaPluginExtend()];

if (isNotProd) {
    enhancers.push(felaMonolithic());

    // felaPluginValidator should be last plugin
    plugins.push(
        felaPluginValidator({
            logInvalid: true,
            deleteInvalid: true,
            useCSSLint: true,
        }),
    );
}

const config = {
    devMode: isNotProd,
    enhancers,
    plugins,
};

export default config;
